import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

import { createPinia } from 'pinia'

import { GridLayout, GridItem } from 'grid-layout-plus'

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

import VueApexCharts from "vue3-apexcharts";

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

createApp(App).component('EasyDataTable', Vue3EasyDataTable).component("font-awesome-icon", FontAwesomeIcon).component('GridLayout', GridLayout).component('GridItem', GridItem).use(createPinia()).use(VueApexCharts).use(router).mount('#app')
